<template>
  <ScheduleToolbelt :tools="tools" />
  <ScheduleEditor />
  <UserGraphView v-if="status" :tools="tools"/>
</template>

<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { Tools } from "@/store/planner/ToolsStore";
import { ErrorStore } from "@/store/ErrorStore";
import ScheduleToolbelt from "@/components/Planner/Graph/ScheduleToolbelt.vue";
import { PeriodSize } from "@/store/planner/CurrentPeriodStore";
import ScheduleEditor from "@/components/Planner/Graph/ScheduleEditor.vue";
import UserGraphView from "@/components/Planner/Graph/user_graph.vue";
import {SP_Drawer_status} from "@/store/planner/SelectedPeriodStore";

export default {
  name: "ScheduleMainPage",
  components: { UserGraphView, ScheduleEditor, ScheduleToolbelt },
  async beforeMount() {
    await this.get_planner_tools()
  },
  data() {
    return {
      periods: null
    }
  },
  computed: {
    status: {
      get() {
        return SP_Drawer_status().get()
      },
      set(value) {
        SP_Drawer_status().set(value)
      }
    },
    errors: {
      get() {
        return ErrorStore().get()
      },
      set(value) {
        ErrorStore().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    },
    tools: {
      get() {
        return Tools().get()
      },
      set(value) {
        Tools().set(value)
      }
    },
    period_size: {
      get() {
        return PeriodSize().get()
      },
      set(value) {
        PeriodSize().set(value)
      }
    }
  },
  methods: {
    get_planner_tools: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetPlannerStats`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      console.log('Получаю список инструментов для Планировщика...')
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            console.log('Успешно!')
            this.tools = JSON.parse(result)
          }).catch((err) => {
            console.log('Ошибка получения данных...')
            console.warn(err)
          })
    }
  }
}
</script>
